<template>
  <v-menu
    :nudge-width="200"
    offset-y
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="secondary-nav-link"
        text
        :ripple="false"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="nav-icon">person</v-icon>
        <span class="pl-2 pr-1">{{ me.firstname }}</span>
        <v-icon class="dropdown-icon">expand_more</v-icon>
      </v-btn>
    </template>
    <n-card>
      <v-list dense class="py-0">
        <v-list-item to="/my-account">
          <v-list-item-icon>
            <v-icon>person</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Mon compte
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="canExport" />
        <v-list-item v-if="canExport" to="/data-exports">
          <v-list-item-icon><v-icon>archive</v-icon></v-list-item-icon>
          <v-list-item-content>Export des données</v-list-item-content>
        </v-list-item>
        <v-divider />
        <template v-if="canGoToAdmin && rights.administration">
          <v-list-item to="/settings">
            <v-list-item-icon>
              <v-icon>settings</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Administration
            </v-list-item-content>
          </v-list-item>
          <v-divider />
        </template>
        <template v-if="isIndeegoUser">
          <v-list-item :href="indeegoSettingsUrl">
            <v-list-item-icon>
              <v-icon>security</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Admin Indeego
            </v-list-item-content>
          </v-list-item>
          <v-divider />
        </template>
        <v-list-item @click="logout">
          <v-list-item-icon>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Déconnexion
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </n-card>
  </v-menu>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(`model/user`, [
      `me`,
    ]),
    ...mapGetters(`model/user`, [
      `isIndeegoUser`,
    ]),
    ...mapState(`model/client`, [
      `company`,
      `rights`,
    ]),
    canExport() {
      if (!this.$store.state.platform.exportsVisible) return false;
      return this.me && this.company && this.me.role === `administrator` && this.me.Client_id === this.company.id && Boolean(this.company.slug);
    },
    canGoToAdmin() {
      return this.me && this.company && ((this.me.role === `administrator` && this.me.Client_id === this.company.id) || this.me.isIndeego);
    },
    indeegoSettingsUrl() {
      return this.$getSlugUrl(`admin`);
    },
    globalLogoutUrl() {
      return `${this.$getSlugUrl(`app`)}/logout`;
    },
  },
  methods: {
    async logout() {
      const isLoggedWithUsername = this.me?.username && this.me?.username.length;
      await this.$store.dispatch(`model/auth/logout`);
      if (isLoggedWithUsername) {
        this.$router.push({ name: `login` });
      } else {
        window.location.href = this.globalLogoutUrl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-icon {
  color: #FFF !important;
  font-size: 1.2rem !important;
  padding: 5px !important;
  background-color: $primaryColor;
  // background-color: rgba(211, 211, 211, .25);
  // border: 1px solid rgba(255, 255, 255,.15);
  border-radius: 100%;
  .v-btn & {
    height: auto !important;
    width: auto !important;
  }
}

.secondary-nav-link {
  text-decoration: none !important;
  color: $primaryColor !important;
  // color: #FFF !important;

  &.highlighted {
    padding: 3px !important;
    padding-top: 5px !important;
    padding-bottom: 7px !important;
    padding-right: 8px !important;
    background-color: rgba(211, 211, 211, .25);
    border: 1px solid rgba(255, 255, 255,.15);
    border-radius: 20px;

    &:hover {
      background-color: rgba(211, 211, 211, .35);
    }

    .v-icon {
      color: #FFF;
      font-size: 1.2rem;
      padding: 3px;
    }
  }

  &.v-btn {
    height: auto !important;
    width: auto !important;
    min-width: 0px !important;
    padding: 0 !important;
    text-transform: none;
    letter-spacing: inherit;
  }
}

.dropdown-icon {
  font-size: 0.9rem !important;
  color: inherit !important;
  opacity: .7;
}
</style>
